import { render, staticRenderFns } from "./RecentActivities.vue?vue&type=template&id=d88caf5c"
import script from "./RecentActivities.vue?vue&type=script&lang=js"
export * from "./RecentActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports